<template>
  <el-dialog :title="$t('repairPoolManage.dispatch')" :visible.sync="visible" width="650px" custom-class="repair-design-dialog" @close="resetForm">
    <el-form ref="form" :model="formData" label-width="86px" class="repair-dialog-form">
      <el-form-item v-if="formData.action === 'BACK'" label="维修人" prop="staffName">
        <el-input v-model="formData.staffName" disabled />
      </el-form-item>

      <el-form-item v-else label="维修人" prop="staffId" :rules="[{ required: true, message: $t('repairPoolManage.selectRepairPerson'), trigger: 'change' }]">
        <el-select v-model="formData.staffId" placeholder="请选择" style="width: 100%">
          <el-option v-for="item in repairTypeUsers" :key="item.staffId" :label="item.staffName" :value="item.staffId" />
        </el-select>
      </el-form-item>

      <el-form-item label="说明" prop="context" :rules="[{ required: true, message: '请输入说明', trigger: 'blur' }]">
        <el-input v-model="formData.context" placeholder="请输入" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer repair-dialog-footer">
      <el-button class="dialog-cancel-btn" @click="visible = false">取消</el-button>
      <el-button type="primary" class="dialog-submit-btn" @click="submitForm">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { dispatchRepair } from '@/api/work/repairPoolManageApi'
import {listRepairTypeUsers} from '@/api/work/repairTypeUserApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getUserId } from '@/api/user/userApi'

export default {
  name: 'DispatchRepair',
  data() {
    return {
      visible: false,
      formData: {
        repairId: '',
        repairType: '',
        communityId: '',
        staffId: '',
        staffName: '',
        context: '',
        action: '',
        communityId: '',
        repairTypeUsers: [],
        currentUserId: ''
      },
      repairTypeUsers: []
    }
  },
  methods: {
    open(repair) {
      this.formData = {
        ...this.formData,
        repairId: repair.repairId,
        repairType: repair.repairType,
        communityId: repair.communityId || getCommunityId(),
        action: repair.action || 'DISPATCH',
        currentUserId: getUserId()
      }

      if (repair.action === 'BACK') {
        this.formData.staffId = repair.preStaffId
        this.formData.staffName = repair.preStaffName
      }

      this.listRepairTypeUsers()
      this.visible = true
    },

    async listRepairTypeUsers() {
      try {
        const params = {
          page: 1,
          row: 50,
          communityId: this.formData.communityId,
          repairType: this.formData.repairType,
          state: '9999'
        }

        const res = await listRepairTypeUsers(params)
        this.repairTypeUsers = res.data || []
      } catch (error) {
        console.error('Failed to fetch repair type users:', error)
      }
    },

    async submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const staff = this.repairTypeUsers.find(item => item.staffId === this.formData.staffId)
            if (staff) {
              this.formData.staffName = staff.staffName
            }

            if (this.formData.action === 'TRANSFER' && this.formData.currentUserId === this.formData.staffId) {
              this.$message.error(this.$t('repairPoolManage.cannotTransferSelf'))
              return
            }

            const data = {
              ...this.formData,
              communityId: this.formData.communityId
            }

            await dispatchRepair(data)
            this.$message.success(this.$t('common.operationSuccess'))
            this.visible = false
            this.$emit('success')
          } catch (error) {
            console.error('Dispatch repair failed:', error)
            this.$message.error(error.message || error)
          }
        }
      })
    },

    resetForm() {
      this.$refs.form.resetFields()
      this.formData = {
        repairId: '',
        repairType: '',
        communityId: '',
        staffId: '',
        staffName: '',
        context: '',
        action: '',
        communityId: '',
        repairTypeUsers: [],
        currentUserId: getUserId()
      }
    }
  }
}
</script>

<style scoped>
.repair-dialog-form { padding: 8px 24px 0; }
.repair-dialog-form >>> .el-form-item { margin-bottom: 24px; }
.repair-dialog-form >>> .el-form-item__label { color: #1D2129; font-weight: 400; white-space: nowrap; }
.repair-dialog-form >>> .el-input__inner { height: 38px; border-radius: 8px; border-color: #DCE6F5; }
.repair-dialog-footer { display: flex; justify-content: flex-end; gap: 12px; }
.dialog-cancel-btn, .dialog-submit-btn { width: 74px; height: 38px; padding: 0; border-radius: 10px; }
.dialog-cancel-btn { color: #0E76FF; border-color: #0E76FF; background: #fff; }
.dialog-submit-btn { background: #0E76FF; border-color: #0E76FF; }
</style>

<style>
.repair-design-dialog .el-dialog__header { height: 66px; padding: 22px 24px 0; text-align: left; border-bottom: 1px solid #DCE6F5; box-sizing: border-box; }
.repair-design-dialog .el-dialog__title { color: #1D2129; font-size: 16px; font-weight: 500; line-height: 22px; }
.repair-design-dialog .el-dialog__headerbtn { top: 22px; right: 24px; }
.repair-design-dialog .el-dialog__body { padding: 24px 0 0; }
.repair-design-dialog .el-dialog__footer { padding: 0 24px 24px; }
</style>
